import CryptoJS from "crypto-js"
import SparkMD5 from "spark-md5"

export const KB = 1024
export const MB = 1024 * KB
export const chunkSize = 10 * MB; // 切片大小
export const appSecret = 'd3e76bc8172f8d42189ad892dfebb352'

export const getCurrentTime = () => {
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth() + 1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
    return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
}
export const encrypt = (word, keyStr) => { // 加密
    const key = CryptoJS.enc.Utf8.parse(keyStr);
    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: keyStr,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }); // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）
    return encrypted.ciphertext.toString().toUpperCase();
}


// 计算分片大小
export const computedSliceSize = (fileSize) => {
    let s10MaxSize = 1000 * 10 * MB
    let s20MaxSize = 1000 * 20 * MB
    let s50MaxSize = 1000 * 50 * MB
    if (fileSize < s10MaxSize) return 10 * MB
    if (fileSize < s20MaxSize) return 20 * MB
    if (fileSize < s50MaxSize) return 50 * MB
    return (Math.floor(fileSize / (2000 * 10 * MB)) + 1) * 10 * MB
}
/**
 * 获取文件MD5值
 * @param file
 */
export const md5File = async (file) => {
    return new Promise(function (resolve, reject) {
        const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
        const fileReader = new FileReader()
        const chunkSize = 2097152
        const chunks = Math.ceil(file.size / chunkSize)
        let currentChunk = 0

        //注意点，网上都是 这一步都是有问题的， SparkMD5.ArrayBuffer()
        const spark = new SparkMD5.ArrayBuffer()
        fileReader.onload = function (e) {
            spark.append(e.target.result)
            currentChunk++
            if (currentChunk < chunks) {
                loadNext()
            } else {
                const md5 = spark.end()
                resolve({
                    code: 0,
                    data: md5
                })
            }
        }
        fileReader.onerror = function (error) {
            console.warn('FileReader error.')
            resolve({
                code: 1,
                msg: error
            })
        }

        function loadNext() {
            const start = currentChunk * chunkSize
            const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
            // 注意这里的 fileRaw
            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
        }

        loadNext()
    })
};


/**
 * 分片
 * @param file
 */
export const fileReaderSlice = async (file, currentChunk, chunkSize) => {
    return new Promise((resolve, reject) => {
        let blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
            chunks = Math.ceil(file.size / chunkSize),
            fileReader = new FileReader();
        fileReader.onload = async function (e) {
            resolve(e.target.result)
        };

        fileReader.onerror = function () {
            console.warn("oops, something went wrong.");
        };

        function loadNext() {
            if (currentChunk < chunks) {
                let start = currentChunk * chunkSize,
                    end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
            }
        }

        loadNext();
    })
};